<div class="dialog_main">
  <button type="button" class="dialog_close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog_body">
    <div class="top_title hd_5">
      <h2>{{ 'PartnerProfileSetup' | translate }}</h2>
      <p>{{'AddBankDetails' | translate}}</p>
    </div>
    <form [formGroup]="memberFormGroup" (ngSubmit)="onSubmit()">
      <div class="form_feilds">
        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              matInput
              [placeholder]="'BankName' | translate"
              formControlName="bankName"
              class="form_control" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="bankNameValidator"> </ng-container>
        </div>

        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              matInput
              formControlName="accountHolderName"
              [placeholder]="'AccountHolderName' | translate"
              class="form_control" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="accountNameValidator">
          </ng-container>
        </div>

        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              matInput
              [placeholder]="'Branchname' | translate"
              class="form_control"
              formControlName="branchName" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="branchNameValidator"> </ng-container>
        </div>

        <div class="form_group">
          <mat-form-field appearance="fill">
            <input
              formControlName="bankCode"
              matInput
              [placeholder]="'BankCode' | translate"
              class="form_control" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="bankCodeValidator"> </ng-container>
        </div>
      </div>

      <div class="form_btn">
        <button type="submit" class="btn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>

<ng-template #bankNameValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['bankName'].hasError('required')) {
      <mat-error>
        {{ 'BankName' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
    @if (memberFormGroup.controls['bankName'].hasError('pattern')) {
      <mat-error>{{ 'validFullName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['bankName'].hasError('minLength')) {
      <mat-error>{{ 'minLengthFullName' | translate }}</mat-error>
    }
    @if (memberFormGroup.controls['bankName'].hasError('maxLength')) {
      <mat-error>{{ 'maxLengthFullName' | translate }}</mat-error>
    }
  }
</ng-template>

<ng-template #accountNameValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['accountHolderName'].hasError('required')) {
      <mat-error>
        {{ 'AccountHolderName' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>

<ng-template #branchNameValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['branchName'].hasError('required')) {
      <mat-error>
        {{ 'Branchname' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>

<ng-template #bankCodeValidator>
  @if (submitted) {
    @if (memberFormGroup.controls['bankCode'].hasError('required')) {
      <mat-error>
        {{ 'BankCode' | translate }} {{ 'IsRequired' | translate }}
      </mat-error>
    }
  }
</ng-template>
